export default __webpack_public_path__ + "static/media/calconvert_xl3.952367a8.png";